import type { ConcreteDayDefinition } from "../DayDefinition.js";
import { Colouring_Pages } from "./Colouring_Pages.js";
import { Dad_Jokes } from "./Dad_Jokes.js";
import { Gift_Tags } from "./Gift_Tags.js";
import { Holiday_Video } from "./Holiday_Video.js";
import { Ice_Breakers } from "./Ice_Breakers.js";
import { Media_Recommendations } from "./Media_Recommendations.js";
import { Monday_Motivations } from "./Monday_Motivations.js";
import { Rootree_Radio } from "./Rootree_Radio.js";
import { Scavenger_Hunt } from "./Scavenger_Hunt.js";
import { Wallpaper_Downloads } from "./Wallpaper_Downloads.js";
import { Wrapping_Tutorial } from "./Wrapping_Tutorial.js";
import { Yoga_Tutorials } from "./Yoga_Tutorials.js";

export const warmestWishesDays: ConcreteDayDefinition[] = [
	Gift_Tags,
	Yoga_Tutorials,
	Dad_Jokes,
	Media_Recommendations,
	Wallpaper_Downloads,
	Ice_Breakers,
	Wrapping_Tutorial,
	Colouring_Pages,
	Rootree_Radio,
	Holiday_Video,
	Monday_Motivations,
	Scavenger_Hunt,
];
